import React, { useMemo } from 'react';
import { CellIcon, ClockIcon, divideString, MailMessageIcon } from '@common-fe/common-fe';

import regexp from '@/common/regexp';
import { useOrganizationProperties } from '@/modules/transaction';
interface HelpItem {
  icon: React.ReactNode;
  value: string;
  url?: string;
  rawUrl?: string;
  isCopy?: boolean;
}
const useGetHelpItems = () => {
  const { organizationProperties } = useOrganizationProperties();
  const helpCenter = useMemo(() => {
    return {
      title: organizationProperties?.customerServiceUrlName,
      url: organizationProperties?.customerServiceUrlLink,
    };
  }, [organizationProperties.customerServiceUrlLink, organizationProperties.customerServiceUrlName]);
  const items = useMemo(() => {
    const phoneNumber = `+${organizationProperties?.customerServiceNumber?.replace(regexp.NOT_NUMBERS_REGEXP, '')}`;
    const result: HelpItem[] = [];
    if (organizationProperties?.customerServiceNumber) {
      result.push({
        value: divideString(phoneNumber, [2, 5, 8]),
        rawUrl: phoneNumber,
        icon: <CellIcon size="22px" />,
        isCopy: true,
      });
    }
    if (organizationProperties?.customerServiceEmail) {
      result.push({
        value: organizationProperties.customerServiceEmail,
        url: `mailto:${organizationProperties.customerServiceEmail}`,
        rawUrl: organizationProperties.customerServiceEmail,
        isCopy: true,
        icon: <MailMessageIcon size="medium" color="iconPrimary" />,
      });
    }
    if (organizationProperties?.workingHours) {
      result.push({
        value: organizationProperties.workingHours,
        icon: <ClockIcon size="22px" />,
      });
    }
    return result;
  }, [
    organizationProperties.customerServiceEmail,
    organizationProperties?.customerServiceNumber,
    organizationProperties.workingHours,
  ]);
  return {
    helpCenter,
    items,
  };
};
export default useGetHelpItems;
